import * as React from "react";
import { TeamResource } from "client/resources";
import MultiSelect from "./MultiSelect";
import { FormFieldProps } from "components/form";
import { TeamChip } from "components/Chips";
import LookupResourceChipComponent from "components/LookupResourceChip";
import { ChipIcon } from "components/Chips";

interface TeamMultiSelectProps extends FormFieldProps<string[]> {
    items: TeamResource[];
    label?: string | JSX.Element;
    error?: string;
}

const  TeamTypedMultiSelect = MultiSelect<TeamResource>();
const LookupTeamChip = LookupResourceChipComponent<TeamResource>();

const TeamMultiSelect: React.StatelessComponent<TeamMultiSelectProps> = props => {
    const chipRenderer = (r: TeamResource, onRequestDelete: (event: object) => void) => {
        return <LookupTeamChip
            lookupCollection={props.items}
            lookupId={r.Id}
            type={ChipIcon.Team}
            chipRender={item => <TeamChip
                onRequestDelete={onRequestDelete}
                team={item}
            />}
        />;
    };

    return <TeamTypedMultiSelect
        items={props.items}
        label="Select teams"
        renderChip={chipRenderer}
        {...props} />;
};

export default TeamMultiSelect;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/MultiSelect/TeamMultiSelect.tsx